module.exports = __webpack_public_path__ + "ota-icons.9685e5aed24857adc5a9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-icons/fonts/ota-icons.eot?xst5zg
// module id = 317
// module chunks = 24